import * as Storage from "../lib/Storage.ts";
import FizConfig from "../FizConfig.ts";

export function setAuthorization(authorization : string, rememberme = false){
  if(rememberme){
    Storage.localSet("Authorization",authorization)
    Storage.sessionRemove("Authorization")
  }else{
    Storage.localRemove("Authorization")
    Storage.sessionSet("Authorization",authorization)
  }
}
export function clearAuthorization(){
  Storage.localRemove("Authorization")
  Storage.sessionRemove("Authorization")
}
export function hasAuthorization(){
  return (Storage.localGet("Authorization") || Storage.sessionGet("Authorization"))!==null
}
/**
 *
 * @returns the Authorization of the loggued user or the unloggued standard juste for defining it is a web client
 */
export function getAuthorization(){
  return Storage.localGet("Authorization") || Storage.sessionGet("Authorization") || FizConfig.BASIC_AUTHORIZATION
}
